export enum ServoPermissionsEnum {
  Bike = 'Bike',
  Kaufpreis = 'Kaufpreis',
  Tech = 'Tech',
  SuperAdmin = 'SuperAdmin',
  GarantieVerlaengerung = 'GarantieVerlaengerung'
}
